export default {
  /**
   * 現在の history の内容に合わせて stack, index を更新する
   *
   * @param {State} state
   * @param {Object} current 現在の history の内容
   */
  update (state, current) {
    if (state.stack.length < current.len) {
      // state.stack.length .. current.len - 1 まで不明(外部URL)で埋める
      const len = current.len - state.stack.length - 1
      for (let i = 0; i < len; ++i) {
        state.stack.splice(0, 0, {
          key: 'unknown',
          name: '',
          path: ''
        })
      }
    } else {
      // key から state.stack の何番目を指しているか探す
      const index = state.stack.findIndex(item => item.key === current.key)

      // 見つかった
      if (index >= 0) {
        // state.index を更新する
        state.index = index

        // path が異なるなら、name, path を更新する
        if (state.stack[index].path !== current.path) {
          state.stack[index].name = current.name
          state.stack[index].path = current.path
        }
        return
      }

      // 見つからなかった: 0 .. state.index までを削除する
      state.stack.splice(0, state.index)
    }

    // current を state.stack に積む
    state.stack.splice(0, 0, {
      key: current.key,
      name: current.name,
      path: current.path
    })
    state.index = 0
  }
}
